import React, { Component } from 'react';
import { Segment, Table } from 'semantic-ui-react';
class ConsumerInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'React'
        };
    }

    render() {
        return (
            <Segment.Group horizontal>
                <Segment color="grey">{this.props.title}
                    <Segment.Group horizontal>
                        <Segment>
                            <Table className="small">
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell className="six wide right aligned">Name:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsConsumerLastName + ", " + this.props.consumer.acsConsumerFirstName + " " + this.props.consumer.acsConsumerMiddleName}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide right aligned">SSN:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props._padString(this.props.consumer.acsConsumerSsn, 4)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide right aligned">DOB:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsConsumerDob}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide right aligned">Add 1:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsConsumerAddress1}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide right aligned">Add 2:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsConsumerAddress2}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide right aligned">{this.props.t("state")}:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsRegion}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Segment>
                            <Table className="ui definition small table">
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">{this.props.t("city")}:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsLocality}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Zip Code:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsPostalCode}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Phone:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsPhone}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Alt Phone:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsAltPhone}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Driver's License:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsConsumerDrivingLicense}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Is Business?:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.busniessType === 'Y' ? "Yes" : "No"}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>

                        <Segment>
                            <Table className="ui definition small table">
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Employer:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsEmployerName}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Address:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsEmployerAddress}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">{this.props.t("city")}:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsEmployerLocality}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">{this.props.t("state")}:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsEmployerRegion}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell className="six wide text-right">Phone:</Table.Cell>
                                        <Table.Cell className="ten wide left aligned collapsing">{this.props.consumer.acsEmployerPhone}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Segment.Group>
                </Segment>
            </Segment.Group>
        );
    }
}
export default ConsumerInfo;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/ConsumerInfo.js